exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.widget-wrapper .widget .widgetHeader {\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.widget-wrapper .widget .widgetHeader .widgetTitle {\n  flex: 0 1 auto;\n  margin-right: 8px;\n}\n\n.widget-wrapper .widget .widgetHeader .widgetIcons {\n  flex: 1 0 auto;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-1!./node_modules/postcss-loader??ref--1-2!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js??ref--1-4!./src/js/layout/explorecard/exploreVisWidget.scss
// module id = 420
// module chunks = 0